/**
 * App version surface — single source of truth for the user-
 * visible version label rendered by PWA and admin.
 *
 * Sync with apps/web/package.json + apps/admin/package.json
 * when bumping the major.minor. The patch level is intentionally
 * dropped from the user-visible label (`3.3`, not `3.3.0`). UI
 * version bumps track major/minor cadence, patch ships silently.
 *
 * Render format: `v3.3 · EV Initiative` with `·` U+00B7 and
 * single spaces either side. Both PWA (ProfilePage,
 * SettingsPage) and admin (when added) consume APP_VERSION_LABEL
 * directly so the format stays in lockstep.
 */
export const APP_VERSION = '3.3';
export const APP_VERSION_LABEL = `v${APP_VERSION} · EV Initiative`;
//# sourceMappingURL=version.js.map